// Who and where for the till header: store, till and the signed-in cashier.
// Every field is optional; missing values come back as "".

function readUser() {
  try {
    const raw = typeof localStorage !== "undefined" ? localStorage.getItem("userData") : null;
    return raw ? JSON.parse(raw) || {} : {};
  } catch {
    return {};
  }
}

export function initialsOf(name) {
  const words = String(name || "")
    .trim()
    .split(/[\s._@-]+/)
    .filter(Boolean);
  if (!words.length) return "";
  const first = words[0][0];
  const last = words.length > 1 ? words[words.length - 1][0] : "";
  return `${first}${last}`.toUpperCase();
}

export function tillIdentity(tillData, userData = readUser()) {
  const store = String(tillData?.tillAccess?.csBunit?.name || "").trim();
  const till = String(tillData?.tillAccess?.cwrTill?.till || "").trim();
  const user = String(userData?.user || "").trim();
  return { store, till, user, initials: initialsOf(user) };
}
